let routes = [
  {
    path: '/demande-permis-psychologue-equivalence',
    component: () => import('../views/DemandePermisPsychologueEquivalence.vue'),
    props: true
  },
  {
    path: '/demande-permis-psychologue-equivalence/:step',
    component: () => import('../views/DemandePermisPsychologueEquivalence.vue'),
    props: true
  }
]

export default routes;